import { ColumnConfig, ColumnDataType } from '@aurora';

export const engineModelPotentialIssueColumnsConfig: ColumnConfig[] = [
    {
        type           : ColumnDataType.STRING,
        field          : 'potentialIssue.name',
        searchableField: '$potentialIssue.name$',
        sort           : 'potentialIssue.name',
        translation    : 'Name',
        isUnaccent     : true,
    },
];
